import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { getNavLayout, type NavLayout } from '@/modules/settings/services/navSettingsService'
import { normalizeRole } from '@/modules/shared'
import { subscribeNavChanged } from '@/modules/navigation/events'

export function useNavLayout(): { layout: NavLayout; ready: boolean } {
  const { user, profile } = useAuth()
  const effectiveRole = normalizeRole((profile?.role || '').toLowerCase())
  const [layout, setLayout] = React.useState<NavLayout>('sidebar')
  const [ready, setReady] = React.useState(false)

  React.useEffect(() => {
    let cancelled = false
    const role: 'master'|'member'|'afiliado' = (effectiveRole as any)
    // Afiliado usa sempre menu lateral (sidebar).
    if (role !== 'member') { setLayout('sidebar'); setReady(true); return }
    ;(async () => {
      try {
        // Apenas 'member' consulta a preferencia de layout.
        const v = await getNavLayout('member')
        if (!cancelled) { setLayout(v); setReady(true) }
      } catch {
        if (!cancelled) { setLayout('sidebar'); setReady(true) }
      }
    })()
    return () => { cancelled = true }
  }, [user?.id, effectiveRole])

  React.useEffect(() => {
    const unsub = subscribeNavChanged(async () => {
      const role: 'master'|'member'|'afiliado' = (effectiveRole as any)
      if (role !== 'member') return
      try { setLayout(await getNavLayout('member')); setReady(true) } catch {}
    })
    return () => unsub()
  }, [effectiveRole])

  return { layout, ready }
}

